module.exports = __webpack_public_path__ + "img/wheat.0e862923.png";